import type { FC } from 'react'

import type { TIconProps } from 'types'

const ArrowIconLeft: FC<TIconProps> = ({ className }) => (
  <svg className={className} width='10' height='20' viewBox='0 0 10 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.66435 0.252601C10.0771 0.619519 10.1143 1.25159 9.7474 1.66437L2.33795 10L9.7474 18.3356C10.1143 18.7484 10.0771 19.3805 9.66435 19.7474C9.25157 20.1143 8.6195 20.0772 8.25258 19.6644L0.25258 10.6644C-0.084207 10.2855 -0.084207 9.71453 0.25258 9.33565L8.25258 0.335647C8.6195 -0.0771359 9.25157 -0.114317 9.66435 0.252601Z'
      fill='#19191A'
    />
  </svg>
)

export default ArrowIconLeft
